
import { computed, defineComponent, ref } from 'vue';
import InjectStyles from '@/common/components/InjectStyles.vue';
import { setupComponent } from '@/catalogs/composables/setupComponent';
import { ComponentName } from '@/catalogs/api/configuration/components/ComponentName';
import { CatalogsCommand, ProductsCommand } from '@/catalogs/api/runtime/CommandExecutor';

export default defineComponent({
  name: ComponentName.productSwitch,
  components: {
    InjectStyles,
  },
  props: {
    instanceId: String,
  },

  setup(props) {
    const root = ref<HTMLElement>();
    const { componentName, instance, isReady, isWebComponent, store, t } = setupComponent(
      root,
      props.instanceId,
    );
    const routeView = computed(() => instance.value?.router.routeData.view);
    const switchToProductsView = async () => {
      try {
        await instance.value?.execute(new ProductsCommand());
      } catch (error) {
        // Ignore error
      }
    };
    const switchToCatalogsView = async () => {
      try {
        await instance.value?.execute(new CatalogsCommand());
      } catch (error) {
        // Ignore error
      }
    };

    return {
      root,
      store,
      isReady,
      routeView,
      componentName,
      isWebComponent,
      t,
      switchToProductsView,
      switchToCatalogsView,
    };
  },
});
